export default "__VITE_ASSET__DYz_C_9S__"